import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { failurePackageManagementCard, successPackageManagementCard } from "./PackageManagementCardSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import { IPackageCard } from "../../../Pages/PackageManagement/IPacakageManagement";
import { failureAddPackage, successAddPackage } from "./AddPackageManagementSlicer";
import { failureUpdatePackage, successUpdatePackage } from "./UpdatePackageManagementSlicer";
import { failureDeletePackage, successDeletePackage } from "./DeletePackageManagementSlice";


const PackageManagementCardApi = (action: PayloadAction<any>) => {
  return api.get(`/packageManagement/getByLocation/${action.payload}`);
};
export function* PackageManagementCardCall(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(PackageManagementCardApi,action);
    yield put(successPackageManagementCard(response.data));
  } catch (error) {
    yield put(failurePackageManagementCard(error));
  }
}

// add package
const AddPackageApi = (action: PayloadAction<IPackageCard>) => {
  const data = {
    package_name: action.payload.package_name,
    package_description: action.payload.package_description,
    package_price: action.payload.package_price,
    package_days: action.payload.package_days,
    package_type: action.payload.package_type,
    location_id: action.payload.location_id,
    working_hours: action.payload.working_hours,
  };
  return api.post('/packageManagement', data);
};

export function* AddPackageCall(action: PayloadAction<IPackageCard>) {

  try {
    
    const response: AxiosResponse = yield call(AddPackageApi, action);
    yield put(successAddPackage(response.data));
  } catch (error:any) {
    yield put(failureAddPackage(error.response.data));
  }
}

// update package
const UpdatePackageApi = (action: PayloadAction<IPackageCard>) => {
console.log("action", action);

const url = `/packageManagement/${action.payload.id}`;
 const data = {
    package_name: action.payload.package_name,
    package_description: action.payload.package_description,
    package_price: action.payload.package_price,
    package_days: action.payload.package_days,
    package_type: action.payload.package_type,
    location_id: action.payload.location_id,
    working_hours: action.payload.working_hours,
  };
  return api.patch(url, data);
};

export function* UpdatePackageCall(action: PayloadAction<IPackageCard>) {
  try {
    const response: AxiosResponse = yield call(UpdatePackageApi, action);
    yield put(successUpdatePackage(response.data));
  } catch (error) {
    yield put(failureUpdatePackage(error));
  }
}

// delete Package
const DeletePackageApi = (action: PayloadAction<number>) => {
  return api.delete(`/packageManagement/${action.payload} `);
};
export function* DeletePackageCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeletePackageApi, action);
    yield put(successDeletePackage(response.data));
  } catch (error) {
    yield put(failureDeletePackage(error));
  }
}
